<template>
  <div class="app-sidebar p-fixed h-100">
    <div class="app-sidebar__content d-flex f-column h-100 p-relative">
      <div class="app-sidebar__header">
        <router-link to="/" class="d-block">
          <img src="/img/logo-text.png" alt="Logo" class="d-block" />
        </router-link>

        <div class="language-wrap">
          <Language v-if="false" />
        </div>
      </div>
      <div class="app-sidebar__body f-full child-center f-column">
        <router-link :to="{ name: 'AboutCompany' }" class="app-sidebar-items d-block">О компании</router-link>
        <!-- <router-link
          :to="{ name: 'ApartmentSelection' }"
          class="app-sidebar-items d-block"
        >Выбор квартиры</router-link>-->
        <router-link :to="{ name: 'ReadyObjects' }" class="app-sidebar-items d-block">Наши объекты</router-link>
        <router-link :to="{ name: 'Activities' }" class="app-sidebar-items d-block">Деятельность</router-link>
        <router-link :to="{ name: 'Partners' }" class="app-sidebar-items d-block">Партнеры</router-link>
        <router-link :to="{ name: 'News' }" class="app-sidebar-items d-block">Новости</router-link>
        <router-link :to="{ name: 'Contact' }" class="app-sidebar-items d-block">Контакты</router-link>
      </div>
      <div class="app-sidebar__footer text-white text-center">
        <i>Обратный звонок</i>
        <p class="mb-0 mt-2">
          <span>+998</span> 71 233 33 30
        </p>
      </div>
    </div>
    <div class="app-layer p-absolute"></div>
  </div>
</template>

<script>
import Language from "../Language";
export default {
  components: {
    Language
  }
};
</script>

<style></style>
